import { Drawer, Box, IconButton } from "@mui/material";
import Collapsible from "../Collapsible/Collapsible";
import CloseIcon from "@mui/icons-material/Close";

interface Props {
  open: boolean;
  handleClose: any;
}

const Guidelines = ({ open, handleClose }: Props) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: { maxWidth: 600, minWidth: 300 },
      }}
    >
      <Box>
        <div className="guidelines_wrapper">
          <div className="title_and_limit">
            <h2 className="">FAQ's</h2>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </div>
          <div>
            {" "}
            <Collapsible triggerText="How do I post a job on Forsatak?">
              Posting a job is easy! Simply create an account, add your job
              details including description, skills required, and desired
              qualifications. Then, use your credits to activate the job
              posting.
            </Collapsible>
            <hr />{" "}
            <Collapsible triggerText="Can I manage my job postings and applications?">
              Absolutely! Your Forsatak dashboard allows you to view and
              edit active job postings, track applications, and communicate
              directly with interested candidates.
            </Collapsible>{" "}
            <hr />{" "}
            <Collapsible triggerText="How do Forsatak credits work?">
              Forsatak uses a credit system for job postings. One credit
              equals one job posting.
            </Collapsible>{" "}
            <hr />{" "}
            <Collapsible triggerText="How does Forsatak help me find suitable applicants?">
              Our advanced search filters allow you to find qualified candidates
              based on skills, experience, and other criteria. We also
              prioritize confidentiality and privacy by providing a secure
              platform for job seekers and employers to connect.
            </Collapsible>{" "}
            <hr />{" "}
            <Collapsible triggerText="Is there a limit to how many jobs I can post?">
              There is no limit to the number of jobs you can post on our
              platform. Feel free to post as many job listings as you need to
              fill your vacancies and attract top talent.
            </Collapsible>{" "}
          </div>
        </div>
      </Box>
    </Drawer>
  );
};

export default Guidelines;
